import classes from "./formTextarea.module.css";

export const FormTextarea = ({
  id,
  label,
  rows = 4,
  register,
  validation = {},
  disabled = false,
  readOnly = false,
  value,
  onChange,
  required = false,
}) => {
  return (
    <div className={classes.wrapper}>
      <div
        className={`${classes.inputBox} ${readOnly ? classes.readOnlyBox : ""}`}
      >
        <textarea
          id={id}
          rows={rows}
          readOnly={readOnly}
          disabled={disabled}
          className={classes.textarea}
          placeholder=" "
          // Use react-hook-form registration if provided, else normal value/onChange
          {...(register ? register(id, validation) : {})}
          value={register ? undefined : value}
          onChange={register ? undefined : onChange}
        />
        <label htmlFor={id} className={classes.floatingLabel}>
          {label}
          {required && <span className={classes.asterisk}>*</span>}
        </label>
      </div>
    </div>
  );
};
